import send from '../../utils/fetch'
import { search, searchInArr } from '../../utils/utils'

const state = {
    leads: [],
    // filters: []
    filters: null
}

const actions = {
    async GET_LEADS({ commit, getters, dispatch }, date) {
        try {
            const k = {
                start: new Date(date.startDate).toLocaleString('ru').split(',')[0].split('.').reverse().join('-'),
                end: new Date(date.endDate).toLocaleString('ru').split(',')[0].split('.').reverse().join('-')
            }

            const { data } = await send(`${global.$url.statistic.get}?direction=${date.direction}&start=${k.start}&end=${k.end}`, 'GET')

            commit('SET_LEADS', data.result)
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async GET_DEPOSITS_LEADS({ commit }, date) {
        try {
            const k = {
                start: new Date(date.startDate).toLocaleString('ru').split(',')[0].split('.').reverse().join('-'),
                end: new Date(date.endDate).toLocaleString('ru').split(',')[0].split('.').reverse().join('-')
            }

            const { data } = await send(`${global.$url.deposits.get}?start=${k.start}&end=${k.end}`, 'GET')

            commit('SET_LEADS', data.result)
            return data
        } catch (e) {
            return Promise.reject(e)
        }
    },

    async UPDATE_LEAD ({commit}, info) {
        try {
            const response = await send(info.url, 'PUT', {data: info.data})
            commit('UPDATE_LEAD', response.data.result.lead)
            return response
        } catch (e) {
            return Promise.reject(e)
        }
    },

    DESTROY_LEAD({commit}) {
        commit('DESTROY_LEAD')
    }
}

const mutations = {
    DESTROY_LEAD(state) {
        state.leads = []
    },

    SET_LEADS(state, data) {
        const leads = data.leads.map(lead => Object.assign(lead, {landing_url_sp: lead.landing_url ? lead.landing_url.split('/')[0] : null}))
        state.leads = leads.reverse()
        state.filters = data.filters    
    },

    UPDATE_LEAD(state, payload) {
        state.leads = state.leads.map(lead => {
            return lead.id === payload.id ? {...payload} :  lead
        })
    }
}

const getters = {
    leads: state => state.leads,
    filtersLeads: state => state.filters,
    filterLeads: (state) => {
        return (filter) => {
            for (const obj in filter) {
                if (filter[obj] === null) {
                    delete filter[obj]
                }
            }

            return search(state.leads, filter)
        }
    },
    filterSearch: state => {
        return filter => {
            return searchInArr(state.leads, filter)
        }
    }
}


export default {
    state,
    actions,
    mutations,
    getters
}
